<app-dialog
  class="dialog"
  [(isOpen)]="isOpen"
  [centered]="false"
  data-test-id="upload-eligibility-files-dialog"
>
  @let viewToSee = view(); @let isFileView = viewToSee === 'file'; @let
  isInputView = viewToSee === 'input';
  <div class="nav-buttons">
    <button
      class="nav-button"
      [class.active]="isInputView"
      (click)="handleViewChange('input')"
    >
      Manual Invites
    </button>
    <button
      class="nav-button"
      [class.active]="isFileView"
      (click)="handleViewChange('file')"
    >
      Import Eligibility File
    </button>
  </div>
  @if (isFileView) {
  <app-eligibility-file [(isOpen)]="isOpen"></app-eligibility-file>
  } @else if (isInputView) {
  <app-invite-users [(isOpen)]="isOpen"></app-invite-users>
  }
</app-dialog>
